/**
 * Update date: 09-06-2023
 * Popup select zone component
 */
import { DataGridFull } from 'app/components/DataGrid';
import useAxios from 'axios-hooks';
import { Button, Popup, TextBox, ScrollView } from 'devextreme-react';
import useDictionary from 'hooks/useDictionary';
import React, { useState, useRef, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import LoadPanel from 'app/components/LoadPanel';
import { useApp } from 'app';
interface IPopupSelectZone {
  visible?: boolean;
  onHiding?: () => void;
  text?: string;
  onSubmit?: void | any;
  mode?: 'single' | 'multiple';
  title?: string;
}

function PopupSelectZone({
  visible,
  onHiding,
  text,
  onSubmit,
  mode = 'single',
  title,
}: IPopupSelectZone) {
  const { themePro }: any = useApp();
  const [zoneName, setZoneName] = useState(text);
  const dataRef: any = useRef(null);
  const { t } = useDictionary({});

  const [{ data: resData, loading }, fetchData] = useAxios(
    {
      url: '/core/zone-info/location-default',
      method: 'GET',
    },
    {
      manual: true,
      useCache: false,
      autoCancel: true,
    },
  );

  /**
   * on search
   *
   */
  const onSearch = () => {
    fetchData({
      params: { zoneName },
    });
  };

  /**
   * on ok
   *
   */
  const onOk = () => {
    const selectedRowKeys =
      dataRef?.current?.instance?.option?.()?.selectedRowKeys;
    if (!mode || mode === 'single') {
      onSubmit(selectedRowKeys?.[0]);
    }
    if (mode === 'multiple') {
      onSubmit(selectedRowKeys);
    }
  };
  /**
   * fetch data
   */
  useEffect(() => {
    onSearch();
  }, []);

  const loadingAll = loading;

  const content = () => {
    return (
      <ScrollView width="100%" height="100%">
        <div style={{ padding: '0 15px' }}>
          <LoadPanel visible={loadingAll} />
          {themePro && (
            <div className="modal-popup-header">
              <span className="title-page">{t('Zone')}</span>
              <div>
                <Button
                  stylingMode="contained"
                  type="default"
                  text={t('OK')}
                  icon="check"
                  style={{ marginRight: 5 }}
                  onClick={onOk}
                />
                <Button
                  stylingMode="contained"
                  text={t('Cancel')}
                  icon="close"
                  onClick={onHiding}
                />
              </div>
            </div>
          )}
          <div
            style={
              themePro
                ? {
                    padding: 8,
                    backgroundColor: '#fff',
                    borderRadius: 6,
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: 20,
                    boxShadow:
                      '0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)',
                  }
                : {
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    marginBottom: 20,
                  }
            }
          >
            <TextBox
              width={themePro ? 400 : '40vw'}
              defaultValue={zoneName}
              onValueChanged={e => setZoneName(e?.value)}
              onEnterKey={onSearch}
              style={{ marginRight: 10 }}
            />
            <Button icon="search" text={t('Search')} onClick={onSearch} />
          </div>
          <DataGridFull
            ref={dataRef}
            dataSource={resData?.data}
            fixedLeft={2}
            fixedRight={0}
            columns={[
              {
                dataField: 'zoneId',
                caption: t('ID'),
                allowSearch: false,
              },
              {
                dataField: 'zoneName',
                caption: t('Zone'),
              },
              {
                dataField: 'zoneStockInterlockTf',
                caption: t('Stock Interlock'),
                editorType: 'dxSwitch',
              },
              {
                caption: t('Location Code'),
                dataField: 'locationId',
              },
              {
                caption: t('Location'),
                dataField: 'locationName',
              },
              {
                caption: t('Default'),
                dataField: 'zoneUseTf',
                editorType: 'dxSwitch',
              },
              {
                caption: t('Router Order'),
                dataField: 'zoneOrder',
              },
              {
                caption: t('Operation'),
                dataField: 'locationOperation',
              },
              {
                caption: t('Priority'),
                dataField: 'locationPriority',
              },
              {
                caption: t('Distribution PeriodDm'),
                dataField: 'locationDistributionPeriodDm',
              },
              {
                caption: t('Note'),
                dataField: 'zoneNt',
              },
            ]}
            options={{
              // keyExpr: 'code',
              onRowDblClick: onOk,
              onToolbarPreparing: (e: any) => {
                e.toolbarOptions.items.unshift({
                  location: 'before',
                  template: 'totalCount',
                });
              },
              selection: {
                mode: mode,
              },
              height: themePro
                ? 'calc(100vh - 200px)'
                : isMobile
                ? 'calc(80vh - 200px)'
                : 'calc(70vh - 200px)',
              columnAutoWidth: true,
            }}
          />
          {!themePro && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 20,
              }}
            >
              <Button icon="save" text={t('OK')} onClick={onOk} />
              <Button icon="close" text={t('Cancel')} onClick={onHiding} />
            </div>
          )}
        </div>
      </ScrollView>
    );
  };

  return (
    <Popup
      className="modal-content-popup"
      visible={visible}
      onHiding={onHiding}
      title={t('Zone')}
      contentRender={content}
      height={themePro ? '100vh' : isMobile ? '80vh' : '70vh'}
      width={isMobile ? '96%' : '60vw'}
      position={{
        boundaryOffset: { x: undefined, y: 50 },
      }}
    />
  );
}

export default PopupSelectZone;
